import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('cost-table');

app.factory('CostTable', resource);
